import React from 'react';
import ReactCardFlip from "react-card-flip";
import QuickLink from "../../../SharedComponents/QuickLink";
import { Link } from "react-router-dom";
import contributors from "../../../assets/cms/contributors.json";
import "../styles/CardStyles.css";
import OptimisedImage from '../../../SharedComponents/OptimisedImage';

function TopicCredits(people) {
  return Object.entries(people).map(([role, person]) => (
    <div className="TopicCredits" key={person}>
      <p className="role">{role}</p>
      <Link key={person} to={"/contributors/" + contributors[person].tag}>
        <p className="name">{contributors[person].name}</p>
      </Link>
    </div>
  ));
}

class TopicCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isFlipped: false,
    };
    this.handleClick = this.handleClick.bind(this);
    this.cardRef = React.createRef();
  }

  handleClick(event) {
    this.setState((prevState) => ({ isFlipped: !prevState.isFlipped }));
  }

  render() {
    return (
      <div className="card">
        <div className="cardcontent">
          <div style={{ display: "none" }}>
            <OptimisedImage image={this.props.image} alt="card background image" onLoad={e => {
              this.cardRef.current.style.backgroundImage = `url(${e.target.currentSrc})`;
            }}/>
          </div>
          <ReactCardFlip isFlipped={this.state.isFlipped} infinite>
            <div className="cardFront" onClick={this.handleClick} ref={this.cardRef}>
              <div className="cardTitleBar" style={{backgroundColor: this.props.colour}}/>
              <h1 className="cardTitle">{this.props.name}</h1>
            </div>
            <div className="cardBack" onClick={this.handleClick} style={{border: "2px solid" + this.props.colour}}>
              <p className="desc">{this.props.desc}</p>
              {TopicCredits(this.props.people)}
              <QuickLink type="external" text="Read more" link={this.props.link}/>
            </div>
          </ReactCardFlip>
        </div>
      </div>
    );
  }
}

export default TopicCard;